$('#model-company').on('change', function() {
$('.main_area > .m2').empty();
var _this = $(this);
let brandName = _this.val();
if (brandName == 'Apple') {
console.log('us');
$('.main_area > .m2').prepend(`
<div class="Apple">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
            <option value="iPhone 17 Pro Max">iPhone 17 Pro Max</option>
      <option value="iPhone 17 Pro">iPhone 17 Pro</option>
      <option value="iPhone 17 Air">iPhone 17 Air</option>
      <option value="iPhone 17">iPhone 17</option>
      <option value="iPhone 16 Pro Max">iPhone 16 Pro Max</option>
      <option value="iPhone 16 Pro">iPhone 16 Pro</option>
      <option value="iPhone 16 Plus">iPhone 16 Plus</option>
      <option value="iPhone 16E">iPhone 16E</option>
      <option value="iPhone 16">iPhone 16</option>
      <option value="iPhone 15 Pro Max">iPhone 15 Pro Max</option>
      <option value="iPhone 15 Pro">iPhone 15 Pro</option>
      <option value="iPhone 15 Plus">iPhone 15 Plus</option>
      <option value="iPhone 15">iPhone 15</option>
      <option value="iPhone 14 Pro Max">iPhone 14 Pro Max</option>
      <option value="iPhone 14 Pro">iPhone 14 Pro</option>
      <option value="iPhone 14 Plus">iPhone 14 Plus</option>
      <option value="iPhone 14">iPhone 14</option>
      <option value="iPhone 13 Pro Max">iPhone 13 Pro Max</option>
      <option value="iPhone 13 Pro">iPhone 13 Pro</option>
      <option value="iPhone 13 Mini">iPhone 13 Mini</option>
      <option value="iPhone 13">iPhone 13</option>
      <option value="iPhone 12 Pro Max">iPhone 12 Pro Max</option>
      <option value="iPhone 12 Pro">iPhone 12 Pro</option>
      <option value="iPhone 12 Mini">iPhone 12 Mini</option>
      <option value="iPhone 12">iPhone 12</option>
      <option value="iPhone 11 Pro Max">iPhone 11 Pro Max</option>
      <option value="iPhone 11 Pro">iPhone 11 Pro</option>
      <option value="iPhone 11">iPhone 11</option>
      <option value="iPhone XS MAX">iPhone XS MAX</option>
      <option value="iPhone XS">iPhone XS</option>
      <option value="iPhone X">iPhone X</option>
      <option value="iPhone XR">iPhone XR</option>
      <option value="iPhone SE 2020">iPhone SE 2020</option>
      <option value="iPhone 8+">iPhone 8+</option>
      <option value="iPhone 8">iPhone 8</option>
      <option value="iPhone 7+">iPhone 7+</option>
      <option value="iPhone 7">iPhone 7</option>
      <option value="iPhone 6s+">iPhone 6s+</option>
      <option value="iPhone 6s">iPhone 6s</option>
      <option value="iPhone 6">iPhone 6</option>
      
    </select>
  </p>
</div>
`);
}
if (brandName == 'Samsung') {
$('.main_area > .m2').prepend(` <div class="Samsung">
  <p class="line-item-property__field">
    <label>Select Model</label>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Samsung Z Fold 4">Samsung Z Fold 4</option>
      <option value="Samsung S25 Ultra">Samsung S25 Ultra</option>
      <option value="Samsung S25+">Samsung S25+</option>
      <option value="Samsung S25 FE">Samsung S25 FE</option>
      <option value="Samsung S25">Samsung S25 </option>
      <option value="Samsung S24 Ultra">Samsung S24 Ultra</option>
      <option value="Samsung S24+">Samsung S24+</option>
      <option value="Samsung S24 FE">Samsung S24 FE</option>
      <option value="Samsung S24">Samsung S24</option>
      <option value="Samsung S23 Ultra">Samsung S23 Ultra</option>
      <option value="Samsung S23 Plus">Samsung S23 Plus</option>
      <option value="Samsung S23 FE">Samsung S23 FE</option>
      <option value="Samsung S23">Samsung S23</option>
      <option value="Samsung S22 Ultra">Samsung S22 Ultra</option>
      <option value="Samsung S22 Plus">Samsung S22 Plus</option>
      <option value="Samsung S22">Samsung S22</option>
      <option value="Samsung S21 Ultra">Samsung S21 Ultra</option>
      <option value="Samsung S21 Plus">Samsung S21 Plus</option>
      <option value="Samsung S21">Samsung S21</option>
      <option value="Samsung S21 FE 5G">Samsung S21 FE 5G</option>
      <option value="Samsung S20 Ultra">Samsung S20 Ultra</option>
      <option value="Samsung S20 Plus">Samsung S20 Plus</option>
      <option value="Samsung S20 FE">Samsung S20 FE</option>
      <option value="Samsung S20">Samsung S20</option>
      <option value="Samsung S10 Plus">Samsung S10 Plus</option>
      <option value="Samsung S10 Lite">Samsung S10 Lite</option>
      <option value="Samsung S10 5G">Samsung S10 5G</option>
      <option value="Samsung S10">Samsung S10</option>
      <option value="Samsung Note 20 Ultra">Samsung Note 20 Ultra</option>
      <option value="Samsung Note 20">Samsung Note 20</option>
      <option value="Samsung Note 10 Plus">Samsung Note 10 Plus</option>
      <option value="Samsung Note 10 Lite">Samsung Note 10 Lite</option>
      <option value="Samsung Note 10">Samsung Note 10</option>
      <option value="Samsung Note 9">Samsung Note 9</option>
      <option value="Samsung Note 8">Samsung Note 8</option>
      <option value="Samsung A73">Samsung A73</option>
      <option value="Samsung A72">Samsung A72</option>
      <option value="Samsung A71">Samsung A71</option>
      <option value="Samsung A56">Samsung A56</option>
      <option value="Samsung A55">Samsung A55</option>
      <option value="Samsung A54">Samsung A54</option>
      <option value="Samsung A53">Samsung A53</option>
      <option value="Samsung A52">Samsung A52</option>
      <option value="Samsung A51">Samsung A51</option>
      <option value="Samsung A50">Samsung A50</option>
      <option value="Samsung A36">Samsung A36</option>
      <option value="Samsung A35">Samsung A35</option>
      <option value="Samsung A34">Samsung A34</option>
      <option value="Samsung A33">Samsung A33</option>
      <option value="Samsung A32 5g">Samsung A32 5g</option>
      <option value="Samsung A32">Samsung A32</option>
      <option value="Samsung A31">Samsung A31</option>
      <option value="Samsung A26">Samsung A26</option>
      <option value="Samsung A25">Samsung A25</option>
      <option value="Samsung A24">Samsung A24</option>
      <option value="Samsung A23">Samsung A23</option>
      <option value="Samsung A22 5g">Samsung A22 5g</option>
      <option value="Samsung A22">Samsung A22</option>
      <option value="Samsung A21s">Samsung A21s</option>
      <option value="Samsung A20s">Samsung A20s</option>
      <option value="Samsung A20/A30">Samsung A20/A30</option>
      <option value="Samsung A17">Samsung A17</option>
      <option value="Samsung A16">Samsung A16</option>
      <option value="Samsung A15">Samsung A15</option>
      <option value="Samsung A14">Samsung A14</option>
      <option value="Samsung A13">Samsung A13</option>
      <option value="Samsung A12">Samsung A12</option>
      <option value="Samsung A11">Samsung A11</option>
      <option value="Samsung A10s">Samsung A10s</option>
      <option value="Samsung A10-">Samsung A10</option>
      <option value="Samsung A07">Samsung A07</option>
      <option value="Samsung A06">Samsung A06</option>
      <option value="Samsung A05s">Samsung A05s</option>
      <option value="Samsung A05">Samsung A05</option>
      <option value="Samsung A04s">Samsung A04s</option>
      <option value="Samsung A04">Samsung A04</option>
      <option value="Samsung A03s">Samsung A03s</option>
      <option value="Samsung A03">Samsung A03</option>
      <option value="Samsung A02s">Samsung A02s</option>
      <option value="Samsung A02">Samsung A02</option>

    </select>

  </p>
</div>`)
}
if (brandName == 'XiaomiRedmi'){
$('.main_area > .m2').prepend(`
<div class="XiaomiRedmi">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Redmi 14C">Redmi 14C</option>
      <option value="Redmi Note 14 Pro">Redmi Note 14 Pro</option>
      <option value="Redmi Note 14">Redmi Note 14</option>
      <option value="Redmi 13C">Redmi 13C</option>
      <option value="Redmi 13">Redmi 13</option>
      <option value="Redmi 12C">Redmi 12C </option>
      <option value="Redmi 12 5G">Redmi 12 5G</option>
      <option value="Redmi 12 ">Redmi 12 </option>
      <option value="Redmi 10A">Redmi 10A </option>
      <option value="Redmi 10C">Redmi 10C </option>
      <option value="Redmi 10 ">Redmi 10 </option>
      <option value="Redmi 9T">Redmi 9T </option>
      <option value="Redmi 9C / 9C NFC">Redmi 9C / 9C NFC </option>
      <option value="Redmi 9A / 9i">Redmi 9A / 9i </option>
      <option value="Redmi 9">Redmi 9 </option>
      <option value="Redmi 8">Redmi 8 </option>
      <option value="Redmi Note 13 Pro">Redmi Note 13 Pro</option>
      <option value="Redmi Note 13">Redmi Note 13</option>
      <option value="Redmi Note 12 Pro">Redmi Note 12 Pro</option>
      <option value="Redmi Note 12s">Redmi Note 12s</option>
      <option value="Redmi Note 12 4G">Redmi Note 12 4G</option>
      <option value="Redmi Note 11 Pro">Redmi Note 11 Pro</option>
      <option value="Redmi Note 11 4G">Redmi Note 11 4G</option>
      <option value="Redmi Note 10 Pro">Redmi Note 10 Pro</option>
      <option value="Redmi Note 10">Redmi Note 10</option>
      <option value="Redmi Note 9 Pro">Redmi Note 9 Pro </option>
      <option value="Redmi Note 9s">Redmi Note 9s </option>
      <option value="Redmi Note 9">Redmi Note 9 </option>
      <option value="Redmi Note 8 Pro">Redmi Note 8 Pro </option>
      <option value="Redmi Note 8">Redmi Note 8 </option>
      <option value="Redmi A1+">Redmi A1+ </option>

    </select>
  </p>
</div>`)
}
if (brandName == 'Huawei'){
$('.main_area > .m2').prepend(`
<div class="Huawei">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Huawei Y9 Prime 2019">Huawei Y9 Prime 2019 </option>
      <option value="Huawei Y9 2019">Huawei Y9 2019 </option>
      <option value="Huawei Y9 2018">Huawei Y9 2018 </option>
      <option value="Huawei Y9a">Huawei Y9a </option>
      <option value="Huawei Y9s">Huawei Y9s </option>
      <option value="Huawei Y8P">Huawei Y8P </option>
      <option value="Huawei Y8s">Huawei Y8s </option>
      <option value="Huawei Y7 Prime 2018">Huawei Y7 Prime 2018 </option>
      <option value="Huawei Y7 2019">Huawei Y7 2019 </option>
      <option value="Huawei Y7P">Huawei Y7P </option>
      <option value="Huawei Y6 Prime 2019">Huawei Y6 Prime 2019 </option>
      <option value="Huawei Y6 Prime 2018">Huawei Y6 Prime 2018 </option>
      <option value="Huawei Y6 Pro 2019">Huawei Y6 Pro 2019 </option>
      <option value="Huawei Y6 2019">Huawei Y6 2019 </option>
      <option value="Huawei Y6 2018">Huawei Y6 2018 </option>
      <option value="Huawei Y6s">Huawei Y6s </option>
      <option value="Huawei Y6P">Huawei Y6P </option>
      <option value="Huawei Y6 II">Huawei Y6 II </option>
      <option value="Huawei Y5 2018">Huawei Y5 2018 </option>
      <option value="Huawei Y5P">Huawei Y5P </option>
      <option value="Huawei Nova 8">Huawei Nova 8 </option>
      <option value="Huawei Nova 8 Pro">Huawei Nova 8 Pro </option>
      <option value="Huawei Nova 7i">Huawei Nova 7i </option>
      <option value="Huawei Nova 4">Huawei Nova 4 </option>
      <option value="Huawei Nova 4e">Huawei Nova 4e </option>
      <option value="Huawei Nova 3">Huawei Nova 3 </option>
      <option value="Huawei Nova 3i">Huawei Nova 3i </option>
      <option value="Huawei Nova 3e">Huawei Nova 3e </option>
      <option value="Huawei Nova 2 Plus">Huawei Nova 2 Plus </option>
      <option value="Huawei Nova 2 Lite">Huawei Nova 2 Lite </option>
      <option value="Huawei P Smart 2020">Huawei P Smart 2020 </option>
      <option value="Huawei P Smart Plus">Huawei P Smart Plus </option>
      <option value="Huawei P Smart S">Huawei P Smart S </option>
      <option value="Huawei Honor 30 Lite">Huawei Honor 30 Lite </option>
      <option value="Huawei Honor 10">Huawei Honor 10 </option>
      <option value="Huawei Honor 10 Lite">Huawei Honor 10 Lite </option>
      <option value="Huawei Honor 9">Huawei Honor 9 </option>
      <option value="Huawei Honor 9a">Huawei Honor 9a </option>
      <option value="Huawei Honor 9i">Huawei Honor 9i </option>
      <option value="Huawei Honor 9c">Huawei Honor 9c </option>
      <option value="Huawei Honor 9s">Huawei Honor 9s </option>
      <option value="Huawei Honor 9 Lite">Huawei Honor 9 Lite </option>
      <option value="Huawei Honor 9x">Huawei Honor 9x </option>
      <option value="Huawei Honor 9x Lite">Huawei Honor 9x Lite </option>
      <option value="Huawei Honor 8">Huawei Honor 8 </option>
      <option value="Huawei Honor 8x">Huawei Honor 8x </option>
      <option value="Huawei Honor 8c">Huawei Honor 8c </option>
      <option value="Huawei Honor 7x">Huawei Honor 7x </option>
      <option value="Huawei Honor 7a">Huawei Honor 7a </option>
      <option value="Huawei Honor 7c">Huawei Honor 7c </option>
      <option value="Huawei Mate 10">Huawei Mate 10 </option>
      <option value="Huawei Mate 10 Pro">Huawei Mate 10 Pro </option>
      <option value="Huawei Mate 10 Lite">Huawei Mate 10 Lite </option>
      <option value="Huawei Mate 20">Huawei Mate 20 </option>
      <option value="Huawei Mate 20 Pro">Huawei Mate 20 Pro </option>
      <option value="Huawei Mate 30">Huawei Mate 30 </option>
      <option value="Huawei Mate 30 Lite">Huawei Mate 30 Lite </option>
      <option value="Huawei Mate 30 Pro">Huawei Mate 30 Pro </option>
      <option value="Huawei Mate 40 Pro">Huawei Mate 40 Pro </option>
      <option value="Huawei P40">Huawei P40 </option>
      <option value="Huawei P40 Pro">Huawei P40 Pro </option>
      <option value="Huawei P40 Lite">Huawei P40 Lite </option>
      <option value="Huawei P30">Huawei P30 </option>
      <option value="Huawei P30 Lite">Huawei P30 Lite </option>
      <option value="Huawei P30 Pro">Huawei P30 Pro </option>
      <option value="Huawei P20 Lite">Huawei P20 Lite </option>
      <option value="Huawei P10">Huawei P10 </option>
      <option value="Huawei P10 Lite">Huawei P10 Lite </option>
      <option value="Huawei P9">Huawei P9 </option>
      <option value="Huawei P9 Lite">Huawei P9 Lite </option>
      <option value="Huawei P8">Huawei P8 </option>
      <option value="Huawei P8 Lite">Huawei P8 Lite </option>
    </select>
  </p>
</div>`)
}
if (brandName == 'Mi'){
$('.main_area > .m2').prepend(`
<div class="Mi">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Mi 11T">Mi 11T</option>
      <option value="Mi 11T Pro">Mi 11T Pro</option>
      <option value="Mi 11">Mi 11</option>
      <option value="Mi 11 Lite">Mi 11 Lite</option>
      <option value="Mi 10T">Mi 10T</option>
      <option value="Mi 10T Pro">Mi 10T Pro</option>
      <option value="Mi 10 Ultra">Mi 10 Ultra</option>
      <option value="Mi 10X 4G">Mi 10X 4G</option>
      <option value="Mi 9T">Mi 9T</option>
      <option value="Mi Note 10 Lite">Mi Note 10 Lite</option>
    </select>
  </p>
</div>`)
}
if (brandName == 'Infinix'){
$('.main_area > .m2').prepend(`
<div class="Infinix">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Infinix Zero 30 5G">Infinix Zero 30 5G</option>
      <option value="Infinix Hot 40i">Infinix Hot 40i</option>
      <option value="Infinix Hot 40">Infinix Hot 40</option>
      <option value="Infinix Hot 30 Play">Infinix Hot 30 Play</option>
      <option value="Infinix Hot 30i">Infinix Hot 30i</option>
      <option value="Infinix Hot 30">Infinix Hot 30</option>
      <option value="Infinix Hot 20s">Infinix Hot 20s</option>
      <option value="Infinix Hot 20i">Infinix Hot 20i</option>
      <option value="Infinix Hot 20">Infinix Hot 20</option>
      <option value="Infinix Hot 12 Play">Infinix Hot 12 Play</option>
      <option value="Infinix Hot 12i">Infinix Hot 12i</option>
      <option value="Infinix Hot 12">Infinix Hot 12</option>
      <option value="Infinix Hot 11 Play">Infinix Hot 11 Play</option>
      <option value="Infinix Hot 11s">Infinix Hot 11s</option>
      <option value="Infinix Hot 11">Infinix Hot 11</option>
      <option value="Infinix Hot 10 Play">Infinix Hot 10 Play</option>
      <option value="Infinix Hot 10s">Infinix Hot 10s</option>
      <option value="Infinix Hot 10i">Infinix Hot 10i</option>
      <option value="Infinix Hot 10">Infinix Hot 10</option>
      <option value="Infinix Hot 9 Play">Infinix Hot 9 Play</option>
      <option value="Infinix Hot 9">Infinix Hot 9</option>
      <option value="Infinix Hot 8">Infinix Hot 8</option>
      <option value="Infinix Note 40 Pro">Infinix Note 40 Pro</option>
      <option value="Infinix Note 40">Infinix Note 40</option>
      <option value="Infinix Note 30 Pro">Infinix Note 30 Pro</option>
      <option value="Infinix Note 30">Infinix Note 30</option>
      <option value="Infinix Note 12 Pro">Infinix Note 12 Pro</option>
      <option value="Infinix Note 12">Infinix Note 12</option>
      <option value="Infinix Note 11 Pro">Infinix Note 11 Pro</option>
      <option value="Infinix Note 11s">Infinix Note 11s</option>
      <option value="Infinix Note 11">Infinix Note 11</option>
      <option value="Infinix Note 10 Pro">Infinix Note 10 Pro</option>
      <option value="Infinix Note 10">Infinix Note 10</option>
      <option value="Infinix Note 8i">Infinix Note 8i</option>
      <option value="Infinix Note 8">Infinix Note 8</option>
      <option value="Infinix Note 7">Infinix Note 7</option>
      <option value="Infinix Smart HD 2021">Infinix Smart HD 2021</option>
      <option value="Infinix Smart 9">Infinix Smart 9</option>
      <option value="Infinix Smart 8">Infinix Smart 8</option>
      <option value="Infinix Smart 7 Plus">Infinix Smart 7 Plus</option>
      <option value="Infinix Smart 7">Infinix Smart 7</option>
      <option value="Infinix Smart 6 HD">Infinix Smart 6 HD</option>
      <option value="Infinix Smart 6">Infinix Smart 6</option>
      <option value="Infinix Smart 5">Infinix Smart 5</option>
      <option value="Infinix Smart 4">Infinix Smart 4</option>
      <option value="Infinix S5 Pro">Infinix S5 Pro</option>
      <option value="Infinix S5">Infinix S5</option>
      <option value="Infinix S4">Infinix S4</option>
    </select>
  </p>
</div>`)
}
if (brandName == 'Oppo'){
$('.main_area > .m2').prepend(`
<div class="Oppo">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Oppo F21 Pro 5G">Oppo F21 Pro 5G</option>
      <option value="Oppo F21 Pro 4G">Oppo F21 Pro 4G</option>
      <option value="Oppo F19 Pro">Oppo F19 Pro</option>
      <option value="Oppo F19">Oppo F19</option>
      <option value="Oppo F17 Pro">Oppo F17 Pro</option>
      <option value="Oppo F17">Oppo F17</option>
      <option value="Oppo F15">Oppo F15</option>
      <option value="Oppo F11 Pro">Oppo F11 Pro</option>
      <option value="Oppo F11">Oppo F11</option>
      <option value="Oppo A96">Oppo A96</option>
      <option value="Oppo A95">Oppo A95</option>
      <option value="Oppo A94">Oppo A94</option>
      <option value="Oppo A93">Oppo A93</option>
      <option value="Oppo A9 2020">Oppo A9 2020</option>
      <option value="Oppo A83">Oppo A83</option>
      <option value="Oppo A79 / A79K">Oppo A79 / A79K</option>
      <option value="Oppo A78">Oppo A78</option>
      <option value="Oppo A77">Oppo A77</option>
      <option value="Oppo A76">Oppo A76</option>
      <option value="Oppo A74 5G">Oppo A74 5G</option>
      <option value="Oppo A73">Oppo A73</option>
      <option value="Oppo A72">Oppo A72</option>
      <option value="Oppo A71">Oppo A71</option>
      <option value="Oppo A60">Oppo A60</option>
      <option value="Oppo A58">Oppo A58</option>
      <option value="Oppo A57 2022">Oppo A57 2022</option>
      <option value="Oppo A57 Old">Oppo A57 Old</option>
      <option value="Oppo A54">Oppo A54</option>
      <option value="Oppo A53">Oppo A53</option>
      <option value="Oppo A52">Oppo A52</option>
      <option value="Oppo A5s">Oppo A5s</option>
      <option value="Oppo A38">Oppo A38</option>
      <option value="Oppo A37">Oppo A37</option>
      <option value="Oppo A36">Oppo A36</option>
      <option value="Oppo A33">Oppo A33</option>
      <option value="Oppo A31">Oppo A31</option>
      <option value="Oppo A18">Oppo A18</option>
      <option value="Oppo A17">Oppo A17</option>
      <option value="Oppo A16K / A16E">Oppo A16K / A16E</option>
      <option value="Oppo A16">Oppo A16</option>
      <option value="Oppo A15 / A15s">Oppo A15 / A15s</option>
      <option value="Oppo A1k / C2">Oppo A1k / C2</option>
    </select>
  </p>
</div>`)
}
if (brandName == 'Reno'){
$('.main_area > .m2').prepend(`
<div class="Reno">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Reno 11F">Reno 11F</option>
      <option value="Reno 7 Pro 5G">Reno 7 Pro 5G </option>
      <option value="Reno 7 4G">Reno 7 4G </option>
      <option value="Reno 6 Pro (5G)">Reno 6 Pro (5G) </option>
      <option value="Reno 6">Reno 6 </option>
      <option value="Reno 5 Pro (5G)">Reno 5 Pro (5G) </option>
      <option value="Reno 5">Reno 5 </option>
      <option value="Reno 4 Pro">Reno 4 Pro </option>
      <option value="Reno 4F / Reno 4 Lite">Reno 4F / Reno 4 Lite </option>
      <option value="Reno 4">Reno 4 </option>
      <option value="Reno 3">Reno 3 </option>
      <option value="Reno 2F / Reno 2Z">Reno 2F / Reno 2Z </option>
      <option value="Reno 2">Reno 2 </option>
    </select>
  </p>
</div>`)
}
if (brandName == 'Vivo'){
$('.main_area > .m2').prepend(`
<div class="Vivo">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Vivo V30e">Vivo V30e</option>
      <option value="Vivo V30">Vivo V30</option>
      <option value="Vivo V29e">Vivo V29e</option>
      <option value="Vivo V29">Vivo V29</option>
      <option value="Vivo V27E">Vivo V27E</option>
      <option value="Vivo V27">Vivo V27</option>
      <option value="Vivo V25E">Vivo V25E</option>
      <option value="Vivo V25">Vivo V25</option>
      <option value="Vivo V23 5G">Vivo V23 5G</option>
      <option value="Vivo V23E">Vivo V23E</option>
      <option value="Vivo V21E">Vivo V21E</option>
      <option value="Vivo V21">Vivo V21</option>
      <option value="Vivo V20 SE">Vivo V20 SE</option>
      <option value="Vivo V20">Vivo V20</option>
      <option value="Vivo V19 / V19 NE">Vivo V19 / V19 NE</option>
      <option value="Vivo V17 Pro">Vivo V17 Pro</option>
      <option value="Vivo V17">Vivo V17</option>
      <option value="Vivo S1 Pro">Vivo S1 Pro</option>
      <option value="Vivo S1">Vivo S1</option>
      <option value="Vivo Y95">Vivo Y95</option>
      <option value="Vivo Y93">Vivo Y93</option>
      <option value="Vivo Y91c / Y91d">Vivo Y91c / Y91d</option>
      <option value="Vivo Y91">Vivo Y91</option>
      <option value="Vivo Y90">Vivo Y90</option>
      <option value="Vivo Y85">Vivo Y85</option>
      <option value="Vivo Y83">Vivo Y83</option>
      <option value="Vivo Y81">Vivo Y81</option>
      <option value="Vivo Y73">Vivo Y73</option>
      <option value="Vivo Y71">Vivo Y71</option>
      <option value="Vivo Y67">Vivo Y67</option>
      <option value="Vivo Y55s">Vivo Y55s</option>
      <option value="Vivo Y55">Vivo Y55</option>
      <option value="Vivo Y53">Vivo Y53</option>
      <option value="Vivo Y51s">Vivo Y51s</option>
      <option value="Vivo Y51">Vivo Y51</option>
      <option value="Vivo Y50">Vivo Y50</option>
      <option value="Vivo Y36">Vivo Y36</option>
      <option value="Vivo Y35">Vivo Y35</option>
      <option value="Vivo Y33s">Vivo Y33s</option>
      <option value="Vivo Y31">Vivo Y31</option>
      <option value="Vivo Y30">Vivo Y30</option>
      <option value="Vivo Y27s">Vivo Y27s</option>
      <option value="Vivo Y27">Vivo Y27</option>
      <option value="Vivo Y22">Vivo Y22</option>
      <option value="Vivo Y21T">Vivo Y21T</option>
      <option value="Vivo Y21">Vivo Y21</option>
      <option value="Vivo Y20 / Y20i">Vivo Y20 / Y20i</option>
      <option value="Vivo Y20s">Vivo Y20s</option>
      <option value="Vivo Y19">Vivo Y19</option>
      <option value="Vivo Y18">Vivo Y18</option>
      <option value="Vivo Y17">Vivo Y17</option>
      <option value="Vivo Y16">Vivo Y16</option>
      <option value="Vivo Y15s">Vivo Y15s</option>
      <option value="Vivo Y15">Vivo Y15</option>
      <option value="Vivo Y12a / Y12s">Vivo Y12a / Y12s</option>
      <option value="Vivo Y12">Vivo Y12</option>
      <option value="Vivo Y11 2019">Vivo Y11 2019</option>
      <option value="Vivo Y03">Vivo Y03</option>
      <option value="Vivo Y02t">Vivo Y02t</option>
      <option value="Vivo Y02s">Vivo Y02s</option>
      <option value="Vivo Y01">Vivo Y01</option>
    </select>
  </p>
</div>`)
}
if (brandName == 'Poco'){
$('.main_area > .m2').prepend(`
<div class="Poco">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Poco X5">Poco X5</option>
      <option value="Poco X3">Poco X3</option>
      <option value="Poco X3 NFC">Poco X3 NFC</option>
      <option value="Poco X3 Pro">Poco X3 Pro</option>
      <option value="Poco X3 GT">Poco X3 GT</option>
      <option value="Poco F3">Poco F3</option>
      <option value="Poco F3 GT">Poco F3 GT</option>
      <option value="Poco M3">Poco M3</option>
      <option value="Poco C40">Poco C40</option>
    </select>
  </p>
</div>`)
}
if (brandName == 'Realme'){
$('.main_area > .m2').prepend(`
<div class="Realme">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Realme Note 50">Realme Note 50</option>
      <option value="Realme X3 GT">Realme X3 GT</option>
      <option value="Realme GT Master">Realme GT Master</option>
      <option value="Realme GT ">Realme GT </option>
      <option value="Realme Narzo 50i">Realme Narzo 50i</option>
      <option value="Realme Narzo 50">Realme Narzo 50</option>
      <option value="Realme 9 Pro Plus">Realme 9 Pro Plus</option>
      <option value="Realme 9 Pro 4G">Realme 9 Pro 4G</option>
      <option value="Realme 9i">Realme 9i</option>
      <option value="Realme 9">Realme 9</option>
      <option value="Realme 8 Pro">Realme 8 Pro</option>
      <option value="Realme 8">Realme 8</option>
      <option value="Realme 7 Pro">Realme 7 Pro</option>
      <option value="Realme 7i">Realme 7i</option>
      <option value="Realme 7">Realme 7</option>
      <option value="Realme 6 Pro">Realme 6 Pro</option>
      <option value="Realme 6 / 6s">Realme 6 / 6s</option>
      <option value="Realme 6i">Realme 6i</option>
      <option value="Realme 5 Pro">Realme 5 Pro</option>
      <option value="Realme 5 / 5i / 5s">Realme 5 / 5i / 5s</option>
      <option value="Realme 3 / 3i">Realme 3 / 3i</option>
      <option value="Realme C67">Realme C67</option>
      <option value="Realme C65">Realme C65</option>
      <option value="Realme C63">Realme C63</option>
      <option value="Realme C55">Realme C55</option>
      <option value="Realme C51">Realme C51</option>
      <option value="Realme C35">Realme C35</option>
      <option value="Realme C33">Realme C33</option>
      <option value="Realme C25-Y">Realme C25-Y</option>
      <option value="Realme C25 / C25s">Realme C25 / C25s</option>
      <option value="Realme C21-Y">Realme C21-Y</option>
      <option value="Realme C21">Realme C21</option>
      <option value="Realme C20 / C20A">Realme C20 / C20A</option>
      <option value="Realme C17">Realme C17</option>
      <option value="Realme C15">Realme C15</option>
      <option value="Realme C12">Realme C12</option>
      <option value="Realme C11 2021">Realme C11 2021</option>
    </select>
  </p>
</div>`)
}
if (brandName == 'Tecno'){
$('.main_area > .m2').prepend(`
<div class="Tecno">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Tecno Camon 30">Tecno Camon 30</option>
      <option value="Tecno Camon 20 Pro Plus">Tecno Camon 20 Pro Plus</option>
      <option value="Tecno Camon 20 Pro">Tecno Camon 20 Pro</option>
      <option value="Tecno Camon 20">Tecno Camon 20</option>
      <option value="Tecno Camon 19 Pro">Tecno Camon 19 Pro</option>
      <option value="Tecno Camon 19 Neo">Tecno Camon 19 Neo</option>
      <option value="Tecno Camon 19">Tecno Camon 19</option>
      <option value="Tecno Camon 18 Premier">Tecno Camon 18 Premier</option>
      <option value="Tecno Camon 18 P">Tecno Camon 18 P</option>
      <option value="Tecno Camon 18 T">Tecno Camon 18 T</option>
      <option value="Tecno Camon 18">Tecno Camon 18</option>
      <option value="Tecno Camon 17 Pro">Tecno Camon 17 Pro</option>
      <option value="Tecno Camon 17">Tecno Camon 17</option>
      <option value="Tecno Camon 16 Pro">Tecno Camon 16 Pro</option>
      <option value="Tecno Camon 16">Tecno Camon 16</option>
      <option value="Tecno Camon 15 Pro">Tecno Camon 15 Pro</option>
      <option value="Tecno Camon 15">Tecno Camon 15</option>
      <option value="Tecno Spark Go 2024">Tecno Spark Go 2024</option>
      <option value="Tecno Spark Go 2023">Tecno Spark Go 2023</option>
      <option value="Tecno Spark 20 Pro Plus">Tecno Spark 20 Pro Plus</option>
      <option value="Tecno Spark 20 Pro">Tecno Spark 20 Pro</option>
      <option value="Tecno Spark 20">Tecno Spark 20</option>
      <option value="Tecno Spark 10 Pro">Tecno Spark 10 Pro</option>
      <option value="Tecno Spark 10C">Tecno Spark 10C</option>
      <option value="Tecno Spark 9T">Tecno Spark 9T</option>
      <option value="Tecno Spark 8 Pro">Tecno Spark 8 Pro</option>
      <option value="Tecno Spark 8C">Tecno Spark 8C</option>
      <option value="Tecno Spark 8">Tecno Spark 8</option>
      <option value="Tecno Spark 7 Pro">Tecno Spark 7 Pro</option>
      <option value="Tecno Spark 7">Tecno Spark 7</option>
      <option value="Tecno Spark 6 Go">Tecno Spark 6 Go</option>
      <option value="Tecno Spark 6">Tecno Spark 6</option>
      <option value="Tecno Pop 7">Tecno Pop 7</option>
      <option value="Tecno Pop 5 Lite">Tecno Pop 5 Lite</option>
      <option value="Tecno Pop 4 Pro">Tecno Pop 4 Pro</option>
      <option value="Tecno Povoiur 4">Tecno Povoiur 4</option>
      <option value="Tecno Pova Neo">Tecno Pova Neo</option>
      <option value="Tecno Pova 5 Pro">Tecno Pova 5 Pro</option>
      <option value="Tecno Pova 2">Tecno Pova 2</option>
      <option value="Tecno Pova">Tecno Pova</option>
    </select>
  </p>
</div>`)
}
if (brandName == 'OnePlus'){
$('.main_area > .m2').prepend(`
<div class="OnePlus">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="One Plus Nord N200">One Plus Nord N200</option>
      <option value="One Plus Nord N100">One Plus Nord N100</option>
      <option value="One Plus Nord N10">One Plus Nord N10</option>
      <option value="One Plus Nord CE 2 Lite">One Plus Nord CE 2 Lite</option>
      <option value="One Plus 10 Pro">One Plus 10 Pro</option>
      <option value="One Plus 9R">One Plus 9R</option>
      <option value="One Plus 9 Pro">One Plus 9 Pro</option>
      <option value="One Plus 9">One Plus 9</option>
      <option value="One Plus 8T">One Plus 8T</option>
      <option value="One Plus 8 Pro">One Plus 8 Pro</option>
      <option value="One Plus 8">One Plus 8</option>
      <option value="One Plus 7T Pro">One Plus 7T Pro</option>
      <option value="One Plus 7T">One Plus 7T</option>
      <option value="One Plus 7 Pro">One Plus 7 Pro</option>
      <option value="One Plus 7">One Plus 7</option>
      <option value="One Plus 6T">One Plus 6T</option>
      <option value="One Plus 6">One Plus 6</option>
    </select>
  </p>
</div>`)
}
if (brandName == 'Google'){
$('.main_area > .m2').prepend(`
<div class="Google">
  <p class="line-item-property__field">
    <label>Select Model</label><br>
    <select required class="required" id="select-model" name="properties[Select Model]">
      <option value="" disabled="disabled" selected="">Select Model Name</option>
      <option value="Pixel 10 Pro XL">Pixel 10 Pro XL</option>
      <option value="Pixel 10 Pro">Pixel 10 Pro</option>
      <option value="Pixel 10">Pixel 10</option>
      <option value="Pixel 9 Pro">Pixel 9 Pro</option>
      <option value="Pixel 9A">Pixel 9A</option>
      <option value="Pixel 9">Pixel 9</option>
      <option value="Pixel 8 Pro">Pixel 8 Pro</option>
      <option value="Pixel 8A">Pixel 8A</option>
      <option value="Pixel 8">Pixel 8</option>
      <option value="Pixel 7 Pro">Pixel 7 Pro</option>
      <option value="Pixel 7A">Pixel 7A</option>
      <option value="Pixel 7">Pixel 7</option>
      <option value="Pixel 6 Pro">Pixel 6 Pro</option>
      <option value="Pixel 6A">Pixel 6A</option>
      <option value="Pixel 6">Pixel 6</option>
      <option value="Pixel 5 XL">Pixel 5 XL</option>
      <option value="Pixel 5A">Pixel 5A</option>
      <option value="Pixel 5">Pixel 5</option>
      <option value="Pixel 4 XL">Pixel 4 XL</option>
      <option value="Pixel 4A 4G">Pixel 4A 4G</option>
      <option value="Pixel 4">Pixel 4</option>
      <option value="Pixel 3 XL">Pixel 3 XL</option>
      <option value="Pixel 3A">Pixel 3A</option>
      <option value="Pixel 3">Pixel 3</option>
    </select>
  </p>
</div>`)
}
// $('.main_area > .m2 > div').removeClass('active');
// $(`.main_area > .m2 > .${brandName}`).addClass('active');
});